import { ROUTES } from '#/config/routes';

function formatQtyForQuery(qty) {
  const n = Number(qty);
  if (!Number.isFinite(n) || n <= 0) {
    return '';
  }
  return String(n);
}

/**
 * 用料需求列（多筆）→ 採購單建立頁 deep link。
 * mtr_id 與 order_qty（採購量 = shortageQty 短缺量）逗號同序；
 * 無短缺的列 order_qty 留空，由採購單頁自行填寫。
 */
export function buildPurchaseOrderCreateUrlFromRequirements(rows = []) {
  const params = new URLSearchParams();
  const entries = (rows ?? [])
    .map((row) => {
      const mtrId = row?.mtr?.id ?? row?.mtrId;
      if (!mtrId) {
        return null;
      }
      return {
        mtrId: String(mtrId),
        orderQty: formatQtyForQuery(row?.shortageQty),
      };
    })
    .filter(Boolean);

  if (entries.length === 0) {
    return ROUTES.purchaseOrderCreate;
  }

  params.set('mtr_id', entries.map((entry) => entry.mtrId).join(','));

  const orderQtys = entries.map((entry) => entry.orderQty);
  if (orderQtys.some(Boolean)) {
    params.set('order_qty', orderQtys.join(','));
  }

  const query = params.toString();
  return query
    ? `${ROUTES.purchaseOrderCreate}?${query}`
    : ROUTES.purchaseOrderCreate;
}
